import { store } from 'store'
import {
  areEntriesLoadedForRoute,
  createDomainLoader,
  getRequiredReducerKeys,
} from 'store/domains/utils/createDomainLoader'
import { domainManifests } from 'store/domains'
import { resolveDomainsForRoute } from 'store/domains/utils/routeDomainIndex'

const loadedModuleKeys = new Set()

const domainLoaders = Object.fromEntries(
  Object.entries(domainManifests).map(([domain, entries]) => [
    domain,
    createDomainLoader(entries, { loadedModuleKeys }),
  ]),
)

const hasDomainReducers = (domain, routeKey) => {
  const entries = domainManifests[domain] || []
  const requiredKeys = getRequiredReducerKeys(entries, routeKey)

  if (!requiredKeys.length) {
    return true
  }

  const reducerMap = store.reducerManager.getReducerMap()
  const state = store.getState()

  return requiredKeys.every((key) => Boolean(reducerMap[key]) && state[key] !== undefined)
}

const isDomainReady = (domain, routeKey) => {
  const entries = domainManifests[domain] || []

  // Covers saga-only domains (e.g. oauth) that have no reducers to check.
  if (!areEntriesLoadedForRoute(entries, routeKey, loadedModuleKeys)) {
    return false
  }

  return hasDomainReducers(domain, routeKey)
}

export const areRouteModulesReady = (pathname, routeKey) => {
  const domains = resolveDomainsForRoute(pathname, routeKey)

  if (!domains.length) {
    return true
  }

  return domains.every((domain) => isDomainReady(domain, routeKey))
}

export const ensureRouteModulesLoaded = async (pathname, routeKey) => {
  const domains = resolveDomainsForRoute(pathname, routeKey)

  await Promise.all(
    domains.map(async (domain) => {
      const loader = domainLoaders[domain]
      if (!loader) {
        return
      }

      await loader(routeKey)
    }),
  )
}
